import CheckIcon from '@mui/icons-material/Check'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { ButtonBase, Drawer, IconButton, Stack } from '@mui/material'
import { useState } from 'react'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { usePersonaStore } from '../../../../../store/usePersonaStore'
import { companyTypeItems } from './content'
import { getCompanyTypeName, getJobCategoryName } from './getNames'
const WhatTheyDo = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenForCompany, setIsOpenForCompany] = useState(false)
  const { locale } = useTranslation()

  const { companyTypeId, setCompanyTypeId, jobCategories, jobCategoryId, setJobCategoryId } = usePersonaStore()

  const selectJobCategory = (id: any) => {
    setJobCategoryId(id)
    setIsOpen(false)
  }
  const selectCompany = (id: number) => {
    setIsOpenForCompany(false)
    setCompanyTypeId(id)
  }
  return (
    <div className="flex flex-col p-[20px]">
      <span className="Headline3-22Bd">상대방은 어떤 일을 하나요?</span>

      <div className="mt-[32px]">
        <span className="Title2-18Bd">직무</span>
        <div
          onClick={(e) => setIsOpen(true)}
          className="border-gray-300 items-center flex px-[12px] mt-[12px]"
          style={{ borderWidth: 1, height: 42, borderRadius: 8, position: 'relative' }}
        >
          {getJobCategoryName(jobCategories, jobCategoryId, locale)}
          <IconButton style={{ position: 'absolute', right: 0, top: 0 }}>
            <KeyboardArrowDownIcon />
          </IconButton>
        </div>
      </div>

      <div className="mt-[32px]">
        <span className="Title2-18Bd">회사</span>
        <div
          onClick={(e) => setIsOpenForCompany(true)}
          className="border-gray-300 items-center flex px-[12px] mt-[12px]"
          style={{ borderWidth: 1, height: 42, borderRadius: 8, position: 'relative' }}
        >
          {getCompanyTypeName(companyTypeId, locale)}

          <IconButton style={{ position: 'absolute', right: 0, top: 0 }}>
            <KeyboardArrowDownIcon />
          </IconButton>
        </div>
      </div>

      <Drawer
        open={isOpen}
        anchor={'bottom'}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
        onClose={(_e) => setIsOpen(false)}
      >
        <div
          style={{
            height: '70vh', // ✅ works as intended
            padding: 20,
            maxHeight: '40%',

            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
            backgroundColor: 'white',
            overflowY: 'scroll',
          }}
        >
          <Stack style={{ width: '100%' }}>
            <span className="Title2-18Md">직무</span>
            {jobCategories.map((item, index) => {
              return (
                <ButtonBase
                  key={index}
                  onClick={(e) => selectJobCategory(item.id)}
                  style={{ height: 54 }}
                  sx={{ justifyContent: 'space-between' }}
                >
                  <div className="Body2-14Md">{getJobCategoryName(jobCategories, item.id, locale)}</div>

                  {item.id === jobCategoryId && (
                    <>
                      <CheckIcon />
                    </>
                  )}
                </ButtonBase>
              )
            })}
          </Stack>
        </div>
      </Drawer>
      <Drawer
        open={isOpenForCompany}
        anchor={'bottom'}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
        onClose={(_e) => setIsOpenForCompany(false)}
      >
        <div
          style={{
            height: '80vh', // ✅ works as intended
            padding: 20,
            overflowY: 'scroll',
            maxHeight: '80%',
            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
            backgroundColor: 'white',
          }}
        >
          <Stack>
            <span className="Title2-18Md">회사</span>
            {companyTypeItems.map((item, index) => {
              return (
                <>
                  <ButtonBase
                    key={index}
                    style={{ height: 54 }}
                    sx={{ justifyContent: 'space-between' }}
                    onClick={(e) => selectCompany(item.id)}
                  >
                    <div className="Body2-14Md">{getCompanyTypeName(item.id, locale)}</div>

                    {item.id === companyTypeId && (
                      <>
                        <CheckIcon />
                      </>
                    )}
                  </ButtonBase>
                </>
              )
            })}
          </Stack>
        </div>
      </Drawer>
    </div>
  )
}

export default WhatTheyDo
